module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-lateral-48d1c9e762321536081ba5e33045ccd9.jpg";